import React from 'react';
import ApplicationSorter from '../Applications/ApplicationSorter';
import Event from '../Event';
import { Tooltip } from 'reactstrap';

export default class ProfileCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tooltip: {
        singleMessage: false,
        notes: false,
        shortlist: false,
        singleShare: false,
        connectUser: false
      }
    };
  }

  coverLetter(e) {
    e.preventDefault();
    Event.fire("contentModal.show", {
      title: "Cover Letter",
      content: this.props.user.formattedCoverLetter ? this.props.user.formattedCoverLetter : this.props.user.coverletter,
      type: this.props.user.formattedCoverLetter ? "html" : "text"
    });
  }

  fireModalEvent(e, modalName) {
    e.preventDefault();
    Event.fire(`${modalName}.show`, this.props.user);
  }

  tooltipToggle(name) {
    let tooltip = this.state.tooltip;
    tooltip[name] = !this.state.tooltip[name];
    this.setState({ tooltip });
  }

  attachedMedia() {
    return this.props.user.files.filter((item) => (item.selfTape));
  }

  // TODO: Move to a separate file to prevent code duplication.
  tooltips(suffix) {
    let modalTooltips = [
      {
        show: true,
        id: "singleMessage",
        event: "singleMessageModal",
        icon: "far fa-envelope-open",
        activeClass: "",
        tooltipText: "Message"
      },
      {
        show: [2, 3].indexOf(window.loggedInUser.type) > -1,
        id: "notes",
        event: "notesModal",
        icon: "fa fa-pencil-square-o",
        activeClass: this.props.user.note ? "active" : "",
        tooltipText: "Notes"
      },
      {
        show: [2, 3].indexOf(window.loggedInUser.type) > -1,
        id: "shortlists",
        event: "shortlistModal",
        icon: "far fa-star",
        activeClass: this.props.shortlisted ? "active" : "",
        tooltipText: "Shortlists"
      },
      {
        show: true,
        id: "singleShare",
        event: "singleShareModal",
        icon: "far fa-share-alt",
        activeClass: "",
        tooltipText: "Share"
      },
      {
        show: window.loggedInUser.type === 1 && this.props.user.type === 1 && window.userConnections.indexOf(this.props.user.access_uid) === -1,
        id: "connectUser",
        event: "connectUserModal",
        icon: "far fa-user-plus",
        activeClass: "",
        tooltipText: "Connect to user"
      }
    ];

    return (
      <div>
        {modalTooltips.map((tooltip) => {
          let id = `${tooltip.id}_tooltip_${this.props.user.uid}_${suffix}`;
          let onClick = !tooltip.event && tooltip.onClick ? tooltip.onClick : e => this.fireModalEvent(e, tooltip.event);
          return tooltip.show ? (
            <a key={id} id={id} href="#" onClick={onClick} className={tooltip.activeClass}>
              <i className={tooltip.icon} aria-hidden="true" />
            </a>
          ) : null;
        })}
        {modalTooltips.map((tooltip) => {
          let id = `${tooltip.id}_tooltip_${this.props.user.uid}_${suffix}`;
          return tooltip.show ? (
            <Tooltip key={`${tooltip.id}_tooltip`} placement="bottom" isOpen={this.state.tooltip[tooltip.id]} target={id} toggle={() => this.tooltipToggle(tooltip.id)}>
              {tooltip.tooltipText}
            </Tooltip>
          ) : null;
        })}
      </div>
    );
  }

  seeAttachedMediaButton() {
    let buttonText = this.attachedMedia()[0].audio_only_video ? 'Demo Read' : 'Self Tape';
    return (
      <div className="text-center mb-1">
        <a target="_blank" href={this.props.user.candidateLink + '&show-file=' + this.props.user.video_uid}>
          <button className="btn btn-xs btn-info">{buttonText}</button>
        </a>
      </div>
    );
  }
  
  render() {
    return (
      <div className="card rounded mb-4 logCard" data-user-uid-log={this.props.user.uid}>
        <a href={this.props.user.candidateLink} target="_blank" className="no-print">
          <button type="button" className="btn btn-secondary btn-sm quick-view">
            View Profile
          </button>
        </a>

        <div className="card-img-container">
          <a href={this.props.user.candidateLink} target="_blank">
            <img className="card-img-top img-fluid" loading="lazy" src={this.props.imageUrl} alt={`${this.props.user.firstname} ${this.props.user.lastname}`} />
          </a>
        </div>
        <div className="card-body">
          <h5 className="card-title one-line-ellipsis">
            <a href={this.props.user.candidateLink} target="_blank">{`${this.props.user.firstname} ${this.props.user.lastname}`}</a>
          </h5>
          {this.props.user.primaryjobtxt && this.props.user.primaryjobtxt !== "" && this.props.user.primaryjoburl ? (
            <p className="text-center secondary small sex-loc">
              <a className="no-color" href={this.props.user.primaryjoburl}>
                {this.props.user.primaryjobtxt}
              </a>
            </p>
          ) : null}
          {this.props.user.sex !== undefined || this.props.user.state ? (
            <p className="text-center secondary small sex-loc">
              {this.props.user.sex !== undefined && [0,1].indexOf(this.props.user.sex) > -1
                ? this.props.user.sex
                  ? "Male /"
                  : "Female /"
                : ""}{" "}
              {this.props.user.state}
            </p>
          ) : null}
          <div className="text-center usr-actions no-print">
            {window.loggedInUser ? this.tooltips("ProfileCard") : null}
          </div>
          {window.loggedInUser && window.loggedInUser.type === 2 && this.attachedMedia().length ? this.seeAttachedMediaButton() : null}
          {window.loggedInUser && window.loggedInUser.type === 2 && this.props.user.coverletter ? (
            <div className="coverletter-wrapper">
              <p className="secondary small intro">
                {this.props.user.coverletter.substr(0, 200)}
                {this.props.user.coverletter.length > 200 ? (
                  <a href="#" onClick={e => this.coverLetter(e)}>
                    ... read more
                    </a>
                ) : null}
              </p>
            </div>
          ) : null}
          <ApplicationSorter key={`${this.props.user.uid}_${this.props.user.application_uid}`} className="short no-print" user={this.props.user} />
        </div>
      </div>
    );
  }
}
